import React from "react";

const modalShow = {
  display: "block"
};

const modalHide = {
  display: "none"
}

export default class BootstrapModaComponent extends React.Component{

  onCloseEvent = () => {
    if (this.props.onCloseEvent){
      this.props.onCloseEvent();
    } else {
      console.warn("there is no prop passed for onCloseEvent");
    }
  }

  onClickModal = (event) => {
    const eventTarget = event.target;
    if (eventTarget.id === "modal-wrapper") {
      this.onCloseEvent();
    }
  }

  render(){
    const visible = (this.props.visible === undefined ? true : this.props.visible);
    const itemVisibleClass = (visible ? "show" : "");
    return (<React.Fragment>
      <div
        className={`fade modal-backdrop ${itemVisibleClass}`}
        style={ visible ? modalShow : modalHide}></div>
      <div
        id="modal-wrapper"
        className={`modal fade ${itemVisibleClass}`}
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        aria-hidden={visible}
        onClick={this.onClickModal}
        style={visible ? modalShow : modalHide} >
        <div className="modal-dialog modal-dialog-scrollable" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">{this.props.modal_header}</h5>
              <button 
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={this.onCloseEvent}>
                <i className="fas fa-times-circle"></i>
              </button>
            </div>
            <div className="modal-body">
              {this.props.modal_body}
              {this.props.children}
            </div>
            <div className="modal-footer">
              {this.props.modal_footer}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>);
  }

}